import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";

export default function P300Chart({ data }) {

    const [show, setShow] = useState(false);

    const dataConf = {
        options: {
            chart: {
                id: "basic-bar",
                type: "bar",
                toolbar: {
                    show: false,
                    // tools: {
                    //     download: false,
                    //     selection: true,
                    //     zoom: true,
                    //     zoomin: false,
                    //     zoomout: false,
                    //     pan: true,
                    // },
                },
            },
            grid: {
                // show: true,
                // borderColor: "#e7e7e7",
                // row: {
                //     colors: ["#f3f3f3", "transparent"],
                //     opacity: 0.5,
                // },
                padding: {
                    top: 10,
                    right: 10,
                    bottom: 0,
                    left: 10
                }, 
            },
            xaxis: {
                //   categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998 ,1999, 2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008],
                categories: data.seriesList,
                labels: {
                    // show: true,
                    rotate: -90,
                    // offsetX: 0,
                    // offsetY: -5,
                    // maxWidth: 200,
                    maxHeight: 200,
                },
            },
            plotOptions: {
                bar: {
                    borderRadius: 4,
                    //   horizontal: true,
                },
            },
            dataLabels: {
                enabled: false,
            },
            legend: {
                show: true,
                position: "top",
                horizontalAlign: "right",
                floating: true,
                offsetX: 0,
                offsetY: -5,
            },
        },
        series: [
            {
                name: "ประมาณการ",
                data: data.valList1,
                // data: [28, 29, 33, 36, 32, 32, 33],
            },
            {
                name: "เบิกจริง",
                data: data.valList2,
                // data: [12, 11, 14, 18, 17, 13, 13],
            },
            //     {
            //       name: "series-1",
            //       data: [30, 40, 45, 50, 49, 60, 70, 91,30, 40, 45, 50, 49, 60, 70, 91,35,40]
            //     },{
            //         name: "series-2",
            //         data: [20, 34, 40, 49, 55, 48, 64, 90,20, 34, 40, 49, 55, 48, 64, 90,80,70]
            //       }
        ],
    };

    useEffect(() => {
        if (data) {
            setShow(true);
        }
    }, [data]);

    return (
        <div>
            <div className="card" style={{ height: "auto" }}>
                <h2 className="centerText" style={{ textAlign: "center" }}>
                    ค่าแรงรวมทุกสัญญาแยกตามสาขา
                </h2>

                {show === true ? <Chart options={dataConf.options} series={dataConf.series} type="bar" height="500" /> : ""}
            </div>
        </div>
    );
}
